import React from 'react';
import Delete from '@mui/icons-material/Delete';
import { Button, Grid, IconButton, Typography } from '@mui/material';

import { PropertyTextInput } from '@paragon/client-tools';
import { EstimateInfo } from '@paragon/contract-library';
import { NumericField } from '@paragon/material';

interface EstimateSelectedItemPropertiesProps {
  readonly estimateInfo: EstimateInfo;
  readonly setEstimateInfo: React.Dispatch<React.SetStateAction<EstimateInfo>>;
}

export function EstimateOtherMaterials({ estimateInfo, setEstimateInfo }: EstimateSelectedItemPropertiesProps) {
  return (
    <>
      <Typography variant="h5">Other Billable Materials</Typography>
      <Grid container spacing={1}>
        {estimateInfo.otherMaterials.map((otherMaterial, index) => (
          <React.Fragment key={otherMaterial.guid}>
            <Grid size={6}>
              <PropertyTextInput
                property="Description"
                value={otherMaterial.description}
                submit={(description) =>
                  void setEstimateInfo((oldEstimateInfo) => {
                    const updatedOtherMaterials = [...oldEstimateInfo.otherMaterials];
                    updatedOtherMaterials[index] = { ...updatedOtherMaterials[index], description };
                    return { ...oldEstimateInfo, otherMaterials: updatedOtherMaterials };
                  })
                }
                fullWidth
              />
            </Grid>
            <Grid size={4}>
              <NumericField
                label="Cost"
                value={otherMaterial.cost}
                onSubmit={(cost) =>
                  void setEstimateInfo((oldEstimateInfo) => {
                    const updatedOtherMaterials = [...oldEstimateInfo.otherMaterials];
                    updatedOtherMaterials[index] = { ...updatedOtherMaterials[index], cost };
                    return { ...oldEstimateInfo, otherMaterials: updatedOtherMaterials };
                  })
                }
              />
            </Grid>
            <Grid size={2} sx={{ alignContent: 'center' }}>
              <IconButton
                onClick={() =>
                  void setEstimateInfo((oldEstimateInfo) => {
                    const updatedOtherMaterials = [...oldEstimateInfo.otherMaterials];
                    updatedOtherMaterials.splice(index, 1);
                    return { ...oldEstimateInfo, otherMaterials: updatedOtherMaterials };
                  })
                }
              >
                <Delete />
              </IconButton>
            </Grid>
          </React.Fragment>
        ))}
        <Grid size={12}>
          <Button
            variant="outlined"
            sx={{ mt: 1 }}
            onClick={() =>
              void setEstimateInfo((oldEstimateInfo) => ({
                ...oldEstimateInfo,
                otherMaterials: [...oldEstimateInfo.otherMaterials, getNewOtherMaterial()],
              }))
            }
          >
            Add New Other Material
          </Button>
        </Grid>
      </Grid>
    </>
  );
}

function getNewOtherMaterial() {
  return { description: '', cost: 0, guid: crypto.randomUUID() };
}
